import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/employee-stats/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const employeeStats = {
  get: apiPathFunc(pathBase),
} as const;
